<script>
import Vue from 'vue';
export default {
	props: {
		eventObject: {}		//-- イベントオブジェクト
	},
	data() {
		return {
			eventBus: new Vue({})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/base.vue